import {combineReducers} from 'redux';
import sessionStorage from 'redux-persist/lib/storage/session'
import {evt, evts} from './evt';
import {cmEnums} from './cmenums';
import {global, loginByOauth} from './global';
import {createWhitelistFilter} from "redux-persist-transform-filter";
import {tickets} from "./ticket";
import { gpbyattds} from './checkin';



const sessionStoragePersistConfig = {
    key: 'root',
    storage: sessionStorage,
    transforms: [
        createWhitelistFilter('cmEnums', []),
        createWhitelistFilter('shopingCart', [])
    ]
};

const rootReducer = combineReducers({
    loginByOauth,
    tickets,
    global,
    cmEnums: cmEnums,
    evt,
    evts,
    gpbyattds,
  
   
});

export default rootReducer


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js